import { getCatalogUrl } from 'src/utils/getUrl';
import { getAssetUrl } from 'src/services/http/user';

export const links = [
  getCatalogUrl('?type=Team+training'),
  'https://university.atlassian.com/student/all_events',
  'https://ace.atlassian.com/community-led-classes/',
];

export const trainingBenefits = {
  heading: 'Training benefits',
  subheading: 'Each type of live training moves you closer to your goals. Choose which works best for you and:',
  list: [
    {
      icon: getAssetUrl(`/images/liveTraining/People.svg`),
      paragraph: 'Get answers to your questions in real time',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Ace.svg`),
      paragraph: 'Learn from expert instructors with practical industry knowledge',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Check.svg`),
      paragraph: 'Expand your network by learning alongside like-minded peers',
    },
  ],
  buttonLabel: undefined,
  link: undefined,
  analyticsButtonLabel: undefined,
};

export const teamTraining = {
  heading: 'Team training',
  subheading: 'Purchase a customized training for your team of 10-15 to accelerate adoption and improve engagement.',
  list: [
    {
      icon: getAssetUrl(`/images/liveTraining/People.svg`),
      paragraph: 'Learn with your team',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Ace.svg`),
      paragraph: 'Receive instruction from an Atlassian-authorized training partner',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Check.svg`),
      paragraph: 'Engage in hands-on practice environments to cement your learning and test your skills',
    },
  ],
  buttonLabel: 'See team training classes',
  link: links[0],
  analyticsButtonLabel: 'teamTrainingClassesButton',
};

export const publicClasses = {
  heading: 'Public classes',
  subheading: 'Sign up individually for a class that works with your schedule.',
  list: [
    {
      icon: getAssetUrl(`/images/liveTraining/People.svg`),
      paragraph: 'Learn from an Atlassian authorized training partner',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Ace.svg`),
      paragraph: 'Engage in hands-on practice environments',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Check.svg`),
      paragraph: 'Cement your learning and test your skills',
    },
  ],
  buttonLabel: 'See public classes',
  link: links[1],
  analyticsButtonLabel: 'publicClassesButton',
};

export const communityLedClasses = {
  heading: 'Community-led classes',
  subheading: 'Learn from a Community expert — and passionate Atlassian power user — for free.',
  list: [
    {
      icon: getAssetUrl(`/images/liveTraining/People.svg`),
      paragraph: 'Enjoy as many classes as you want — completely free of charge',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Ace.svg`),
      paragraph: 'Learn quickly (classes are often 60 minutes or less)',
    },
    {
      icon: getAssetUrl(`/images/liveTraining/Check.svg`),
      paragraph: 'Get access to a Community expert and their authentic user perspective',
    },
  ],
  buttonLabel: 'See community-led classes',
  link: links[2],
  analyticsButtonLabel: 'communityLedClassesButton',
};
